/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignupUrlRequest } from '../../models/signup-url-request';
import { SignupUrlResponse } from '../../models/signup-url-response';

export interface AggregatorsDoordashSignupUrlPost$Params {
  'Active-Tenant-Identifier': string;
      body: SignupUrlRequest
}

export function aggregatorsDoordashSignupUrlPost(http: HttpClient, rootUrl: string, params: AggregatorsDoordashSignupUrlPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SignupUrlResponse>> {
  const rb = new RequestBuilder(rootUrl, aggregatorsDoordashSignupUrlPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SignupUrlResponse>;
    })
  );
}

aggregatorsDoordashSignupUrlPost.PATH = '/aggregators/doordash/signup-url';
